import { render, staticRenderFns } from "./NewPlace.vue?vue&type=template&id=181e9a42&scoped=true&"
import script from "./NewPlace.vue?vue&type=script&lang=js&"
export * from "./NewPlace.vue?vue&type=script&lang=js&"
import style0 from "./NewPlace.vue?vue&type=style&index=0&id=181e9a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e9a42",
  null
  
)

export default component.exports